/*
 * Intelligent Fabric — expanded sidebar logo (mark + wordmark).
 */
import LogoIcon from './LogoIcon';

const LogoFull = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '4px 0' }}>
      <LogoIcon />
      <div style={{ lineHeight: 1.05 }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: '#e8ecf7', letterSpacing: 0.2 }}>
          Intelligent Fabric
        </div>
        <div
          style={{
            fontSize: 9.5,
            color: '#59617e',
            textTransform: 'uppercase',
            letterSpacing: 1.4,
            marginTop: 2,
          }}
        >
          Admin Console
        </div>
      </div>
    </div>
  );
};

export default LogoFull;
